function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgStoerungWhite = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 50 50",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round"
    },
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "stoerung-white",
    transform: "matrix(0.884042,0,0,0.884042,8.70617,9.06082)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.624,16L12.312,16C12.492,16 12.661,16.076 12.767,16.205C12.871,16.328 12.902,16.498 12.849,16.65L6.979,33.17L24.627,14L21.313,14C21.112,14.004 20.923,13.902 20.815,13.732C20.719,13.569 20.733,13.363 20.851,13.215L30.364,1L14.953,1L8.624,16ZM5.562,36C5.469,36 5.378,35.979 5.294,35.939C5.057,35.826 4.944,35.578 5.027,35.35L11.545,17L7.812,17C7.633,17.002 7.463,16.923 7.35,16.785C7.246,16.655 7.222,16.477 7.287,16.324L14.037,0.324C14.132,0.121 14.338,-0.006 14.562,0L31.437,0C31.647,0 31.839,0.103 31.937,0.268C32.033,0.431 32.019,0.638 31.9,0.785L22.385,13L25.812,13C26.021,12.995 26.217,13.105 26.321,13.286C26.414,13.459 26.385,13.674 26.248,13.816L5.998,35.816C5.885,35.936 5.727,36.003 5.562,36Z",
    style: {
      fill: "white",
      stroke: "white",
      strokeWidth: "0.9px"
    }
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgStoerungWhite, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/stoerung-white.c65460ab.svg";
export { ForwardRef as ReactComponent };